import { useTranslation } from 'react-i18next';
import { FilterChips, FilterType } from 'src/components/molecules/filter-chips';
import {
  IssueStateFilterValue,
  issueStateFilterValues,
} from 'src/features/issues/constants/issue-state/issue-state-filter-values';
import { issueStateTranslations } from 'src/features/issues/constants/issue-state/issue-state-translations';
import {
  SpaceChangeFilterValue,
  spaceChangeFilterValues,
} from 'src/features/issues/constants/issue-state/space-change/space-change-filter-values';
import { spaceChangeTranslations } from 'src/features/issues/constants/issue-state/space-change/space-change-translations';
import { HandleChangeFilterValue } from 'src/types/handle-change-filter-value';
import { Filters } from 'src/types/interfaces/filters';

interface Props {
  filters: Filters;
  handleChangeFilterValue: HandleChangeFilterValue;
}

export const IssuesFilterChips = ({
  filters,
  handleChangeFilterValue,
}: Props) => {
  const { t } = useTranslation(['issues', 'spaces']);

  const findStatusFilterTranslation = (value: IssueStateFilterValue) => {
    if (value === issueStateFilterValues.NEW) {
      return `${t('issues:common.state.title')}: ${t(issueStateTranslations.NEW)}`;
    }

    if (value === issueStateFilterValues.IN_PROGRESS) {
      return `${t('issues:common.state.title')}: ${t(issueStateTranslations.IN_PROGRESS)}`;
    }
    if (value === issueStateFilterValues.RESOLVED) {
      return `${t('issues:common.state.title')}: ${t(issueStateTranslations.RESOLVED)}`;
    }
    if (value === issueStateFilterValues.REJECTED) {
      return `${t('issues:common.state.title')}: ${t(issueStateTranslations.REJECTED)}`;
    }

    return '';
  };

  const findSpaceChangeFilterTranslation = (value: SpaceChangeFilterValue) => {
    if (value === spaceChangeFilterValues.true) {
      return `${t('issues:common.spaceChangeRequested.title')}: ${t(spaceChangeTranslations.true)}`;
    }

    if (value === spaceChangeFilterValues.false) {
      return `${t('issues:common.spaceChangeRequested.title')}: ${t(spaceChangeTranslations.false)}`;
    }

    return '';
  };

  const filterTypes: FilterType[] = [
    {
      value: 'status',
      text: value =>
        findStatusFilterTranslation(value as IssueStateFilterValue),
    },
    {
      value: 'spaceChange',
      text: value =>
        findSpaceChangeFilterTranslation(value as SpaceChangeFilterValue),
    },
  ];

  return (
    <FilterChips
      filters={filters}
      handleChangeFilterValue={handleChangeFilterValue}
      filterTypes={filterTypes}
    />
  );
};
